import {h} from 'preact';
import LinkList from '../link-list';

const NamesList = ({...props}) => (
  <LinkList
    resultLinkPathIdKey="id"
    textKey={["voornaam", "tussenvoegsel", "achternaam"]}
    filterKey="achternaam"
    database={props.databaseKey}
    dbType={props.listPath}
    {...props}
  />
);

export default NamesList;
